import { useAppSelector } from "../../../app/hooks";
import { selectCurrentCommercialPlan } from "../../../slices/chatSlice";
import CommercialPlanGrid from "./commercialPlanGrid";
import SimulatorSummary from "./simulatorSummary";
import VolumeDriversSummary from "./volumeDriversSummary";
import ScenarioDefinition from "./scenarioDefinition";

const CommercialPlanPanel: React.FC = () => {
    const currentPlan = useAppSelector(selectCurrentCommercialPlan);

    return (
        <>
            <ScenarioDefinition />
            <SimulatorSummary planData={currentPlan} />
            <VolumeDriversSummary isLoading={currentPlan == null} />
            <CommercialPlanGrid planData={currentPlan} />
        </>
    );
};

export default CommercialPlanPanel;
